import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import type { HistoryFormValues } from '../../models/vessels/maritime-ais-api';
import HistoryPanelSampleRate from './history-panel-sample-rate';

dayjs.extend(utc);

type IHistoryPanelState = {
  aisDataGapLength: number;
  refreshData: boolean;
  resultsViewOpen: boolean;
  formValues: HistoryFormValues;
  enableMergedStationaryPoints: boolean;
  token: string | undefined;
};

const FORMATTED_TODAY = dayjs().utc().toISOString();

const FORMATTED_ONE_MONTH_AGO = dayjs()
  .utc()
  .subtract(1, 'month')
  .toISOString();

export const INITIAL_HISTORY_PANEL_STATE: IHistoryPanelState = {
  aisDataGapLength: 24,
  refreshData: false,
  resultsViewOpen: false,
  formValues: {
    identifiers: '',
    startDate: FORMATTED_ONE_MONTH_AGO,
    endDate: FORMATTED_TODAY,
    sampleRate: HistoryPanelSampleRate.ONE_HOUR,
  },
  enableMergedStationaryPoints: false,
  token: undefined,
};

const HistoryPanelSlice = createSlice({
  name: 'historyPanel',
  initialState: INITIAL_HISTORY_PANEL_STATE,
  reducers: {
    setAISDataGapLength: (state, action: PayloadAction<number>) => {
      state.aisDataGapLength = action.payload;
    },
    setHistoryFormValues: (
      state,
      action: PayloadAction<Partial<HistoryFormValues> | null>
    ) => {
      // Only updates filters explictly mentioned in action
      state.formValues = {
        ...state.formValues,
        ...action.payload,
      };
    },
    setEnableMergedStationaryPoints: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.enableMergedStationaryPoints = action.payload;
    },
    setToken: (state, action: PayloadAction<string | undefined>) => {
      state.token = action.payload;
    },
  },
});

export const {
  setHistoryFormValues,
  setAISDataGapLength,
  setEnableMergedStationaryPoints,
  setToken,
} = HistoryPanelSlice.actions;

export default HistoryPanelSlice.reducer;
